import classNames from 'classnames';
import React from 'react';
import ErrorIcon from 'images/v5/icons/badge-error.svg';
import SuccessIcon from 'images/v5/icons/badge-success.svg';
import WarningIcon from 'images/v5/icons/badge-warning.svg';
import styles from './StatusPill.module.scss';
const defaultColors = {
    neutral: 'var(--semantic-text-onsubtle-neutral)',
    info: 'var(--semantic-text-onsubtle-info)',
    success: 'var(--semantic-text-onsubtle-positive)',
    error: 'var(--semantic-text-onsubtle-negative)',
    warning: 'var(--semantic-text-onsubtle-notice)',
};
function StatusPill({ display = 'inline', theme = 'plain', size = 'm', type = 'neutral', customIcon = false, color, onClick, text, children, }) {
    const classes = classNames(styles[display], styles.wrap, styles[theme], styles[size], styles[type], {
        [styles.click]: onClick,
    });
    const icons = {
        neutral: React.createElement(SuccessIcon, null),
        info: React.createElement(SuccessIcon, null),
        success: React.createElement(SuccessIcon, null),
        error: React.createElement(ErrorIcon, null),
        warning: React.createElement(WarningIcon, null),
    };
    const icon = (React.createElement("span", { className: styles.icon, style: { color: color || defaultColors[type] } }, icons[type]));
    if (onClick) {
        return (React.createElement("div", { "aria-hidden": "true", role: "button", className: classes, onClick: (e) => onClick(e) },
            customIcon || icon,
            " ",
            React.createElement("p", null, text || children)));
    }
    return (React.createElement("div", { className: classes },
        customIcon || icon,
        " ",
        React.createElement("p", null, text || children)));
}
export default StatusPill;
